<div class="col-md-12 p-0 float-right d-flex justify-content-end">
  <button class="btn back-btn p-1 font-lg-size" (click)="goBack()">
    <i class="fas fa-level-down-alt fa-rotate-90" aria-hidden="true"></i>
  </button>
</div>
